module.exports = __webpack_public_path__ + "static/media/geo.a0c282a3.svg";